/* eslint-disable import/prefer-default-export,react/jsx-key */
import React, { useEffect, useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
// eslint-disable-next-line import/no-unresolved
import { MAIN_ICON_COLORS } from 'assets/components';
import PropTypes from 'prop-types';
import { dynamicAssets } from '../../../../utilities/helpers';
import { FLOWS, sendStats } from '../../../../services/mixpanel';
import { MXP_ONBOARDING_SIGN_UP_CREATE_ACCOUNT } from '../../../../screens/Onboarding/mixpanel-events';
import { PromoGridLayout } from '../PromoGridLayout';
import { Typography } from '../../../../components';
import { ICONS } from '../../../../components/Icon/constants';
import Icon from '../../../../components/Icon';
import { useUsEnv } from '../../../../utilities/sharedHooks/useUsEnv';

export const PromoContent = ({ isUSA }) => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const { isUsEnv } = useUsEnv();

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const imagesStyle = useMemo(() => {
    const result = {
      mainCardImage: {
        width: '100%',
      },
      topCardImage: {
        width: '100%',
      },
      bottomCardImage: {
        width: '100%',
      },
      mainCardContainer: {
        position: 'absolute',
        top: 50,
        right: -60,
      },
      topCardContainer: {
        position: 'absolute',
        top: -100,
        right: isUSA ? 190 : 210,
      },
      bottomCardContainer: {
        position: 'absolute',
        bottom: -95,
        right: 210,
      },
    };

    if (screenWidth <= 1024) {
      result.mainCardImage.width = '75%';
      result.topCardImage.width = '75%';
      result.bottomCardImage.width = '90%';
      result.mainCardContainer.display = 'flex';
      result.mainCardContainer.justifyContent = 'end';
      result.mainCardContainer.top = 100;
      result.topCardContainer.top = 10;
      result.topCardContainer.right = 20;
      result.bottomCardContainer.bottom = 50;
      result.bottomCardContainer.right = 20;
    }

    return result;
  }, [isUSA, screenWidth]);

  return (
    <div>
      <div
        className="d-flex flex-column w-100 position-relative"
        style={{ marginTop: '41px', minHeight: '665px' }}>
        <div style={{ position: 'absolute', top: -30, right: 80 }}>
          <img alt="clipboard" src={dynamicAssets('./assets/images/promo-gradient.png')} />
        </div>
        <div style={imagesStyle.topCardContainer}>
          <img
            style={imagesStyle.topCardImage}
            alt="clipboard"
            src={dynamicAssets(
              isUSA ? './assets/images/promo-us-image-1.png' : './assets/images/promo-image-1.png'
            )}
          />
        </div>
        <div style={imagesStyle.bottomCardContainer}>
          <img
            style={imagesStyle.bottomCardImage}
            alt="clipboard"
            src={dynamicAssets(
              isUSA ? './assets/images/promo-us-image-2.png' : './assets/images/promo-image-2.png'
            )}
          />
        </div>
        <PromoGridLayout />
        <div style={imagesStyle.mainCardContainer}>
          <img
            style={imagesStyle.mainCardImage}
            alt="clipboard"
            src={
              isUSA
                ? dynamicAssets('./assets/images/promo-us-image-3.png')
                : dynamicAssets('./assets/images/promo-image-3.png')
            }
          />
        </div>
        <div style={{ zIndex: 10, flex: 1 }}>
          <Typography as="h1" className="main-title-text promo-main-title  w-100">
            {translate('promo_title_browser_1')}
          </Typography>
          <h1 className="main-title-text promo-main-title  w-100">
            <Trans
              i18nKey="promo_title_browser_2"
              components={[<span className="masked-text" />]}
            />
          </h1>
          <div className="promo-subtitle" style={{ marginTop: '32px' }}>
            <Typography
              as="p"
              variant="base"
              className="text-white"
              style={{ fontFamily: 'Test Sohne' }}>
              {isUSA ? translate('promo_title_body_us') : translate('promo_title_body')}
            </Typography>
          </div>
          <div style={{ width: '13rem', minWidth: '13rem', marginTop: '24px' }}>
            <button
              onClick={() => {
                sendStats(MXP_ONBOARDING_SIGN_UP_CREATE_ACCOUNT, {}, FLOWS.ONBOARDING);
                history.push('/onboarding/signup');
              }}
              className="btn btn-primary w-100 promo-button d-flex align-items-center justify-content-around"
              type="button">
              {translate('promo_button1_label')}
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ width: '16px', height: '16px' }}>
                <Icon icon={ICONS.RIGHT_ARROW} color={MAIN_ICON_COLORS.WHITE} />
              </div>
            </button>
          </div>
          <div
            className="d-flex flex-wrap promo-features-container"
            style={{ marginTop: '56px', gap: '16px' }}>
            <div className="d-flex flex-column gap-2" style={{ flex: 1 }}>
              <p
                className="text-white"
                style={{
                  whiteSpace: 'pre-line',
                  fontFamily: 'Monument Extended',
                  fontSize: '1.25rem',
                }}>
                {translate('promo_body1').replace(' ', '\n')}
              </p>
              <div style={{ opacity: 0.6, maxWidth: '170px' }}>
                <Typography
                  as="p"
                  variant="small"
                  className="text-white"
                  style={{ fontFamily: 'Test Sohne' }}>
                  {translate('promo_subtitle1')}
                </Typography>
              </div>
            </div>
            <div className=" d-flex flex-column gap-2" style={{ flex: 1 }}>
              <p
                className="text-white"
                style={{
                  whiteSpace: 'pre-line',
                  fontFamily: 'Monument Extended',
                  fontSize: '1.25rem',
                }}>
                {translate(isUsEnv || isUSA ? 'promo_us_body2' : 'promo_body2').replace(' ', '\n')}
              </p>
              <div style={{ opacity: 0.6, maxWidth: '180px' }}>
                <Typography
                  as="p"
                  variant="small"
                  className="text-white"
                  style={{ fontFamily: 'Test Sohne' }}>
                  {isUsEnv || isUSA
                    ? translate('promo_subtitle2_us_1')
                    : translate('promo_subtitle2_1')}
                </Typography>
                {!(isUSA || isUsEnv) && (
                  <Typography
                    as="p"
                    variant="small"
                    className="text-white"
                    style={{ fontFamily: 'Test Sohne' }}>
                    {translate('promo_subtitle2_2')}
                  </Typography>
                )}
              </div>
            </div>
            <div className=" d-flex flex-column gap-2" style={{ flex: 1.5 }}>
              <div className="d-flex flex-column">
                <p
                  className="text-white"
                  style={{
                    fontFamily: 'Monument Extended',
                    fontSize: '1.25rem',
                  }}>
                  0%
                </p>
                <p
                  className="text-white"
                  style={{
                    whiteSpace: 'pre-line',
                    fontFamily: 'Monument Extended',
                    fontSize: '1.25rem',
                  }}>
                  {translate('promo_body3')}
                </p>
              </div>
              <div style={{ opacity: 0.6, maxWidth: '180px' }}>
                <Typography
                  as="p"
                  variant="small"
                  className="text-white"
                  style={{ fontFamily: 'Test Sohne' }}>
                  {isUSA ? translate('promo_us_subtitle3') : translate('promo_subtitle3')}
                </Typography>
              </div>
            </div>
          </div>
          <div
            className="d-flex flex-column"
            style={{ marginTop: '56px', width: '60%', gap: '16px' }}>
            <Typography
              as="p"
              variant="base"
              className="text-white"
              style={{ fontFamily: 'Test Sohne' }}>
              {translate('promo_lunching_soon')}
            </Typography>
            <div className="d-flex" style={{ gap: '38px' }}>
              <div className="d-flex align-items-center">
                <div
                  className="me-2 d-flex justify-content-center align-items-center"
                  style={{ width: '12px', height: '9px' }}>
                  <Icon icon={ICONS.CHECK} color={MAIN_ICON_COLORS.PRIMARY} />
                </div>
                <Typography
                  as="p"
                  variant="small"
                  className="text-white"
                  style={{ opacity: 0.6, fontFamily: 'Test Sohne' }}>
                  {translate('promo_lunching_feature_1')}
                </Typography>
              </div>
              <div className="d-flex align-items-center">
                <div
                  className="me-2 d-flex justify-content-center align-items-center"
                  style={{ width: '12px', height: '9px' }}>
                  <Icon icon={ICONS.CHECK} color={MAIN_ICON_COLORS.PRIMARY} />
                </div>
                <Typography
                  as="p"
                  variant="small"
                  className="text-white"
                  style={{ opacity: 0.6, fontFamily: 'Test Sohne' }}>
                  {translate('promo_lunching_feature_2')}
                </Typography>
              </div>
              {isUSA && (
                <div className="d-flex align-items-center">
                  <div
                    className="me-2 d-flex justify-content-center align-items-center"
                    style={{ width: '12px', height: '9px' }}>
                    <Icon icon={ICONS.CHECK} color={MAIN_ICON_COLORS.PRIMARY} />
                  </div>
                  <Typography
                    as="p"
                    variant="small"
                    className="text-white"
                    style={{ opacity: 0.6, fontFamily: 'Test Sohne' }}>
                    {translate('promo_lunching_feature_us_3')}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-100 bg-light-pink" style={{ height: '1.33px', opacity: 0.05 }} />
      </div>
      <div className="d-flex flex-column w-100 h-100 gap-4 py-4" style={{ opacity: 0.46 }}>
        <div className="d-flex flex-column w-100">
          <Typography as="p" variant="small" className="text-white">
            {isUSA ? translate('promo_disclosure_us_1_1') : translate('promo_disclosure_1_1')}
          </Typography>
          <Typography as="p" variant="small" className="text-white">
            {translate('promo_disclosure_1_2')}
          </Typography>
        </div>
        <Typography as="p" variant="small" className="text-white">
          {translate('promo_disclosure_2')}
        </Typography>
        <Typography as="p" variant="small" className="text-white">
          {translate('promo_disclosure_3')}
        </Typography>
      </div>
    </div>
  );
};

PromoContent.propTypes = {
  isUSA: PropTypes.bool,
};
PromoContent.defaultProps = {
  isUSA: false,
};
